export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-800 text-background-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="font-heading text-2xl text-background-50 tracking-wide">UU漫画</span>
            <p className="text-sm text-background-300 leading-relaxed mt-4">
              UU漫画致力于为漫迷提供<strong className="text-background-100">免费漫画全集</strong>资源，涵盖<strong className="text-background-100">免费完整版漫画</strong>、<strong className="text-background-100">免费漫画大全</strong>等海量内容，支持<strong className="text-background-100">在线免费阅读</strong>，无需付费畅享热门<strong className="text-background-100">免费漫画资源</strong>。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading text-background-50 mb-4">
              <a href="#topics" className="no-underline text-background-50 hover:text-primary-400 transition-colors">热门题材</a>
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#topics" className="text-sm text-background-300 hover:text-background-50 transition-colors">热血漫画</a></li>
              <li><a href="#topics" className="text-sm text-background-300 hover:text-background-50 transition-colors">恋爱漫画</a></li>
              <li><a href="#topics" className="text-sm text-background-300 hover:text-background-50 transition-colors">奇幻漫画</a></li>
              <li><a href="#topics" className="text-sm text-background-300 hover:text-background-50 transition-colors">悬疑漫画</a></li>
              <li><a href="#topics" className="text-sm text-background-300 hover:text-background-50 transition-colors">搞笑漫画</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading text-background-50 mb-4">
              <a href="#index" className="no-underline text-background-50 hover:text-primary-400 transition-colors">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#ranking" className="text-sm text-background-300 hover:text-background-50 transition-colors">热门排行</a></li>
              <li><a href="#updates" className="text-sm text-background-300 hover:text-background-50 transition-colors">追更动态</a></li>
              <li><a href="#cards" className="text-sm text-background-300 hover:text-background-50 transition-colors">精选漫画</a></li>
              <li><a href="#about" className="text-sm text-background-300 hover:text-background-50 transition-colors">关于UU</a></li>
              <li><a href="#faq" className="text-sm text-background-300 hover:text-background-50 transition-colors">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              暂无具体合作信息展示，欢迎通过<strong className="text-background-200">联系我们</strong>洽谈合作事宜。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#contact" className="w-9 h-9 rounded-lg bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-mail-line text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 rounded-lg bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 rounded-lg bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-background-600/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; 2024 UU漫画. 本站所有<strong className="text-background-300">免费漫画全集</strong>资源仅供学习交流，版权归原作者所有。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">服务条款</a>
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors">隐私政策</a>
              <a href="#faq" className="text-xs text-background-400 hover:text-background-200 transition-colors">帮助中心</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}